import { ForwardMessageScreenNavigationProps } from "./types"
import React from "react"
import ForwardMessage from "./forward-message-screen"
import { PageRoot } from "~screens/page-root"


const ForwardMessageScreen: React.FC<ForwardMessageScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <ForwardMessage messageID={route.params.messageID} />
    </PageRoot>
  )
}

export default ForwardMessageScreen
